export default "__VITE_PUBLIC_ASSET__970e16ce__"